export default __webpack_public_path__ + "static/media/Tornhill.15712685.png";